import React, { useState } from 'react';
import { PaperclipIcon, SendIcon, FileIcon } from 'lucide-react';
import { Message } from '../types';
interface MessagingPanelProps {
  messages: Message[];
  embedded?: boolean;
}
export function MessagingPanel({
  messages,
  embedded = false
}: MessagingPanelProps) {
  const [newMessage, setNewMessage] = useState('');
  const wrapperClass = embedded ? 'flex flex-col h-full' : 'bg-white rounded-lg shadow-sm border border-slate-200 flex flex-col h-[400px]';
  return <div className={wrapperClass} data-id="element-62">
      {!embedded && <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 rounded-t-lg shrink-0" data-id="element-63">
          <div className="flex -space-x-2 overflow-hidden" data-id="element-64">
            <div className="inline-flex h-6 w-6 rounded-full ring-2 ring-white bg-blue-100 items-center justify-center text-[10px] font-medium text-blue-700" data-id="element-65">
              MP
            </div>
            <div className="inline-flex h-6 w-6 rounded-full ring-2 ring-white bg-purple-100 items-center justify-center text-[10px] font-medium text-purple-700" data-id="element-66">
              SJ
            </div>
          </div>
          <span className="text-xs text-slate-500 font-medium" data-id="element-67">
            {messages.length} messages
          </span>
        </div>}

      <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-68">
        {messages.map(msg => {
        const isMe = msg.sender === 'Mike Processor';
        return <div key={msg.id} className={`flex gap-3 ${isMe ? 'flex-row-reverse' : ''}`} data-id="element-69">
              <div className={`shrink-0 h-6 w-6 rounded-full flex items-center justify-center text-[10px] font-medium ${isMe ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`} data-id="element-70">
                {msg.initials}
              </div>
              <div className={`flex flex-col ${isMe ? 'items-end' : 'items-start'} max-w-[80%]`} data-id="element-71">
                <div className="flex items-baseline gap-2 mb-0.5" data-id="element-72">
                  <span className="text-xs font-medium text-slate-900" data-id="element-73">
                    {msg.sender}
                  </span>
                  <span className="text-[10px] text-slate-400" data-id="element-74">
                    {msg.timestamp}
                  </span>
                </div>
                <div className={`rounded-xl px-3 py-2 text-xs leading-relaxed ${isMe ? 'bg-blue-600 text-white rounded-tr-sm' : 'bg-slate-100 text-slate-800 rounded-tl-sm'}`} data-id="element-75">
                  <p data-id="element-76">{msg.content}</p>
                </div>

                {msg.attachments && msg.attachments.length > 0 && <div className="mt-1.5 flex flex-col gap-1.5 w-full" data-id="element-77">
                    {msg.attachments.map((file, idx) => <div key={idx} className={`flex items-center gap-1.5 p-1.5 rounded-md border text-xs ${isMe ? 'bg-blue-50 border-blue-100 text-blue-800' : 'bg-white border-slate-200 text-slate-700'}`} data-id="element-78">
                        <FileIcon className="h-3 w-3 shrink-0" data-id="element-79" />
                        <span className="truncate font-medium" data-id="element-80">{file}</span>
                      </div>)}
                  </div>}
              </div>
            </div>;
      })}
      </div>

      <div className="p-3 border-t border-slate-100 bg-white shrink-0" data-id="element-81">
        <div className="relative flex items-end gap-2" data-id="element-82">
          <button className="p-1.5 text-slate-400 hover:text-slate-600 rounded-md hover:bg-slate-100 transition-colors shrink-0" data-id="element-83">
            <PaperclipIcon className="h-4 w-4" data-id="element-84" />
          </button>
          <div className="relative flex-1" data-id="element-85">
            <textarea rows={1} className="block w-full resize-none rounded-lg border-0 py-1.5 pl-3 pr-8 text-slate-900 shadow-sm ring-1 ring-inset ring-slate-300 placeholder:text-slate-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-5" placeholder="Type a message..." value={newMessage} onChange={e => setNewMessage(e.target.value)} style={{
            minHeight: '32px',
            maxHeight: '80px'
          }} data-id="element-86" />
          </div>
          <button className="p-1.5 bg-blue-600 text-white hover:bg-blue-700 rounded-lg transition-colors shrink-0 shadow-sm" data-id="element-87">
            <SendIcon className="h-3.5 w-3.5" data-id="element-88" />
          </button>
        </div>
      </div>
    </div>;
}